import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { observeLazyLoadedChildrenImages } from 'app/helpers/observer'

const WPGImageBlock: React.FC<IWPGBlock> = (props) => {
  const html = props.innerHTML.replace('<img src=', '<img data-src=')

  return (
    <div
      className="wpg-block wpg-b_image"
      dangerouslySetInnerHTML={{ __html: html }}
      ref={observeLazyLoadedChildrenImages}
    />
  )
}

export default WPGImageBlock
